import { FormTypes } from '@oneblink/types'
import cleanFormSubmissionModel from '@oneblink/apps-react/dist/services/cleanFormSubmissionModel'
import { conditionalLogicService } from '@oneblink/sdk-core'

export default function cleanSubmissionModel(
  submission: Record<string, unknown>,
  elements: FormTypes.FormElement[],
) {
  const { formElementsConditionallyShown } =
    conditionalLogicService.generateFormElementsConditionallyShown({
      submission: submission,
      formElements: elements,
      enableSubmission: undefined,
    })

  const { model } = cleanFormSubmissionModel(
    submission,
    elements,
    formElementsConditionallyShown,
    true,
  )

  return model
}
